import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createHead } from '@unhead/vue/client';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import VueKonva from 'vue-konva';
import { appInsightsLoggerPlugin } from '@core/plugins/appInsights';
import App from './App.vue';
import { router } from './routing';
import millersEventsPlugin from './millersEventsPlugin';
import './index.css';
import 'vue-toastification/dist/index.css';
import 'floating-vue/dist/style.css';
import 'vue3-perfect-scrollbar/style.css';

const app = createApp(App);

const head = createHead();

app.use(head);
app.use(router);
app.use(createPinia());
app.use(VueKonva);
app.use(PerfectScrollbarPlugin);
app.use(millersEventsPlugin);
if (import.meta.env.VITE_APPINSIGHTS_CONN) {
  app.use(appInsightsLoggerPlugin, {
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONN,
  });
}

app.mount('#app');
